import { hc } from "hono/client";
import type { AuthPublicRpc } from "@typedoc/auth/rpc/public";
import { validateApiBase, type RpcFetch } from "./transport";

export function createAuthPublicClient(base: string, fetcher?: RpcFetch) {
  return hc<AuthPublicRpc>(validateApiBase(base), {
    ...(fetcher ? { fetch: fetcher } : {}),
    init: { credentials: "include" },
    headers: { Accept: "application/json" },
  });
}

export type AuthPublicClient = ReturnType<typeof createAuthPublicClient>;
